<div class="config-task-node-container" [class.selected]="selected()" [class.archived]="isArchived" (click)="onClick.emit()">
  <div class="config-task-node-inner">
    <app-svg-icon
      class="drag-handle"
      icon="drag-drop-vertical"
      color="var(--color-grey-900)"
      [size]="24"
      [strokeWidth]="3"
    ></app-svg-icon>
    @if (task.editing && this.editData) {
      <div class="summary-item-content-wrapper">
        <div class="summary-item-content edit-container">
          <dx-form
            #form
            class="gpd-form"
            [(formData)]="editData"
            [colCountByScreen]="{ lg: 2, md: 2, sm: 1, xs: 1 }"
            [showColonAfterLabel]="false"
          >
            <dxi-item itemType="group">
              <dxi-item dataField="title" editorType="dxTextBox" [editorOptions]="titleEditorOptions">
                <dxo-label i18n-text="@@title" text="Title" />
                <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
              </dxi-item>

              <dxi-item
                dataField="areaTypeIds"
                [visible]="taskTypesConfig[editData.type].areaTypeIds ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@areaTypes" text="Area Types" template="label">
                  <div *dxTemplate="let item of 'label'" class="task-label required">
                    <span class="dx-field-item-label-text">{{ item.text }}</span>
                    <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-at" [size]="16">
                    </app-svg-icon>
                    <dx-popover
                      target=".help-icon-at"
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                      [wrapperAttr]="{ class: 'gpd-popover' }"
                      position="bottom"
                      style="display: none"
                    >
                      <div class="help-context" i18n="@@areaTypeHelp">
                        Your defined area types will be displayed here. You can set these under the tab "Project
                        Configuration" → "Project Parameters"
                      </div>
                    </dx-popover>
                  </div>
                </dxo-label>
                <div *dxTemplate>
                  <dx-tag-box
                    class="gpd-input"
                    [(value)]="editData.areaTypeIds"
                    [dataSource]="areaTypes"
                    displayExpr="name"
                    valueExpr="id"
                    [searchEnabled]="true"
                    [multiline]="true"
                    [showDropDownButton]="true"
                    [readOnly]="editData.siteTask"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-tag-box>
                </div>
              </dxi-item>

              <dxi-item
                dataField="priority"
                [visible]="taskTypesConfig[editData.type].priority ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@priority" text="Priority" />
                <div *dxTemplate>
                  <dx-select-box
                    class="gpd-input"
                    [(value)]="editData.priority"
                    [dataSource]="priorities"
                    displayExpr="text"
                    valueExpr="id"
                    itemTemplate="item"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>

                    <div *dxTemplate="let item of 'item'" class="priority-item">
                      <app-svg-icon
                        [icon]="priorities[item.id ?? 3].icon"
                        [size]="24"
                        [strokeWidth]="2"
                        [color]="priorities[item.id ?? 3].color"
                      ></app-svg-icon>
                      <span>{{ item.text }}</span>
                    </div>
                  </dx-select-box>
                </div>
              </dxi-item>

              <dxi-item dataField="type" [isRequired]="true" [visible]="editData.type !== TaskTypeEnum.Group">
                <dxo-label i18n-text="@@type" text="Type" />
                <div *dxTemplate>
                  <dx-select-box
                    class="gpd-input"
                    [(value)]="editData.type"
                    [dataSource]="filteredTaskTypes"
                    displayExpr="text"
                    valueExpr="value"
                    [disabled]="!isNew"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>
              </dxi-item>

              <dxi-item
                dataField="documentName"
                [visible]="taskTypesConfig[editData.type].documentName ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@documentName" text="Document Name" />
                <div *dxTemplate>
                  <dx-text-box class="gpd-input" [(value)]="editData.documentName" [maxLength]="70">
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </dxi-item>
              <dxi-item
                dataField="destinationPath"
                [visible]="taskTypesConfig[editData.type].destinationPath ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@targetPath" text="Target Path" />
                <div *dxTemplate>
                  <dx-select-box
                    class="gpd-input"
                    [(value)]="editData.destinationPath"
                    [dataSource]="editData.siteTask ? gridDestinationPaths : fullDestinationPaths"
                    displayExpr="name"
                    valueExpr="id"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>
              </dxi-item>
              <dxi-item
                dataField="templateFilename"
                [visible]="taskTypesConfig[editData.type].templateFilename ?? false"
              >
                <dxo-label i18n-text="@@template" text="Template" />
                <div *dxTemplate>
                  <!-- #173: with template management, local uploads are replaced by managed templates -->
                  <ng-container *ngIf="templateManagementEnabled; else legacyUpload">
                    <dx-drop-down-box
                      class="gpd-input template-picker"
                      [(opened)]="templateDropDownOpened"
                      [value]="selectedTemplateLabel"
                      [showClearButton]="true"
                      [acceptCustomValue]="true"
                      i18n-placeholder="@@selectTemplatePlaceholder"
                      placeholder="Select a template..."
                      (onValueChanged)="onTemplateFieldValueChanged($event)"
                    >
                      <div *dxTemplate="let data of 'content'">
                        <dx-tree-view
                          class="template-tree"
                          [items]="templateTree"
                          dataStructure="plain"
                          keyExpr="id"
                          parentIdExpr="parentId"
                          displayExpr="name"
                          [searchEnabled]="true"
                          searchMode="contains"
                          selectionMode="single"
                          itemTemplate="templateTreeItem"
                          (onItemClick)="selectTemplateNode($event.itemData)"
                        >
                          <div *dxTemplate="let node of 'templateTreeItem'" class="template-tree-item">
                            <app-svg-icon [icon]="node.icon === 'folder' ? 'folder' : 'file'" [size]="16"></app-svg-icon>
                            <span class="template-tree-item-name">{{ node.name }}</span>
                          </div>
                        </dx-tree-view>
                      </div>
                    </dx-drop-down-box>
                    <div
                      *ngIf="editData.templateFilename"
                      class="file-upload-container"
                      (click)="downloadTemplate()"
                    >
                      <span class="file-upload-name">{{ editData.templateFilename }}</span>
                      <app-gpd-button
                        icon="delete"
                        type="text"
                        color="var(--color-red-500)"
                        class="file-delete-icon"
                        (onClick)="deleteTemplateFile()"
                      >
                      </app-gpd-button>
                    </div>
                  </ng-container>
                  <ng-template #legacyUpload>
                    <dx-file-uploader
                      *ngIf="!editData.templateFilename; else templateFile"
                      class="gpd-input"
                      [(value)]="editData.template"
                      (onValueChanged)="onTemplateFileChanged($event)"
                      [uploadMode]="null"
                      [showFileList]="false"
                    ></dx-file-uploader>
                    <ng-template #templateFile>
                      <div class="file-upload-container" (click)="downloadTemplate()">
                        <span class="file-upload-name">{{ editData.templateFilename }}</span>

                        <app-gpd-button
                          icon="delete"
                          type="text"
                          color="var(--color-red-500)"
                          class="file-delete-icon"
                          (onClick)="deleteTemplateFile()"
                        >
                        </app-gpd-button>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </dxi-item>

              <dxi-item
                dataField="userDefinedFields"
                [visible]="taskTypesConfig[editData.type].userDefinedFields ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@userDefinedFields" text="User Defined Fields" />
                <div *dxTemplate>
                  <dx-tag-box
                    class="gpd-input"
                    [(value)]="editData.userDefinedFields"
                    [acceptCustomValue]="true"
                    [openOnFieldClick]="false"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-tag-box>
                </div>
              </dxi-item>

              <dxi-item
                dataField="siteTaskNValidation"
                [visible]="
                  (taskTypesConfig[editData.type].siteTask ?? false) ||
                  (taskTypesConfig[editData.type].validation ?? false)
                "
              >
                <dxo-label [visible]="false" />
                <div *dxTemplate class="sitetask-n-validation-container">
                  <dx-check-box
                    *ngIf="taskTypesConfig[editData.type].siteTask ?? false"
                    class="gpd-input"
                    [(value)]="editData.siteTask"
                    [enableThreeStateBehavior]="false"
                    i18n-text="@@siteTask"
                    text="Site Task"
                    (onValueChanged)="onSiteTaskChange($event)"
                    [disabled]="!isNew"
                  ></dx-check-box>
                  <dx-check-box
                    *ngIf="taskTypesConfig[editData.type].validation ?? false"
                    class="gpd-input"
                    [(value)]="editData.validation"
                    [enableThreeStateBehavior]="false"
                    i18n-text="@@requiresValidation"
                    text="Requires validation"
                  ></dx-check-box>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group">
              <dxi-item dataField="note" [visible]="taskTypesConfig[editData.type].note ?? false">
                <dxo-label i18n-text="@@example" text="Example" />
                <div *dxTemplate>
                  <dx-text-area class="gpd-input" [(value)]="editData.note"></dx-text-area>
                </div>
              </dxi-item>

              <dxi-item
                dataField="departmentId"
                [visible]="taskTypesConfig[editData.type].departmentId ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@department" text="Department" template="label">
                  <div *dxTemplate="let item of 'label'" class="task-label required">
                    <span class="dx-field-item-label-text">{{ item.text }}</span>
                    <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-department" [size]="16">
                    </app-svg-icon>
                    <dx-popover
                      target=".help-icon-department"
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                      [wrapperAttr]="{ class: 'gpd-popover' }"
                      position="bottom"
                      style="display: none"
                    >
                      <div class="help-context" i18n="@@departmentHelp">
                        Your defined departments will be displayed here. You can set these under the tab "General" →
                        "Organizational Structure"
                      </div>
                    </dx-popover>
                  </div>
                </dxo-label>
                <div *dxTemplate>
                  <dx-select-box
                    class="gpd-input"
                    [(value)]="editData.departmentId"
                    [dataSource]="departmentTypes"
                    displayExpr="name"
                    valueExpr="id"
                  >
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>
              </dxi-item>

              <dxi-item
                dataField="estimatedHours"
                [colSpan]="1"
                [visible]="taskTypesConfig[editData.type].estimatedHours ?? false"
                [isRequired]="true"
              >
                <dxo-label i18n-text="@@estimatedTimeInHours" text="Estimated Time in Hours" />
                <div *dxTemplate>
                  <dx-number-box class="gpd-input" [(value)]="editData.estimatedHours">
                    <dx-validator>
                      <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
                    </dx-validator>
                  </dx-number-box>
                </div>
              </dxi-item>

              <dxi-item dataField="helpLink" [visible]="taskTypesConfig[editData.type].helpLink ?? false">
                <dxo-label i18n-text="@@helpLink" text="Help Link" />
                <div *dxTemplate>
                  <dx-text-box class="gpd-input" [(value)]="editData.helpLink"></dx-text-box>
                </div>
              </dxi-item>

              <dxi-item dataField="tagIds" cssClass="task-tags-item" [visible]="taskTypesConfig[editData.type].tags ?? false">
                <dxo-label i18n-text="@@tag" text="Tag" template="tagLabel">
                  <div *dxTemplate="let item of 'tagLabel'" class="task-label">
                    <span class="dx-field-item-label-text">{{ item.text }}</span>
                    <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-tags" [size]="16">
                    </app-svg-icon>
                    <dx-popover
                      target=".help-icon-tags"
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                      [wrapperAttr]="{ class: 'gpd-popover' }"
                      position="bottom"
                      style="display: none"
                    >
                      <div class="help-context" i18n="@@taskTagHelp">
                        Assign tags to this task so it can be filtered by tag in the project overview, the task list and the calendar. The tags apply to this task in every project. Create new tags under "Administration" → "Tags".
                      </div>
                    </dx-popover>
                  </div>
                </dxo-label>
                <div *dxTemplate>
                  <!-- The tag-box only adds/removes via its checklist; selected tags render as the
                       removable pills below (same pattern as contact tags). -->
                  <div class="task-tags-dropdown-wrapper">
                    <dx-tag-box
                      class="gpd-input task-tags-dropdown"
                      [(value)]="editData.tagIds"
                      [items]="taskTags"
                      displayExpr="name"
                      valueExpr="id"
                      [searchEnabled]="true"
                      [showSelectionControls]="true"
                      [showDropDownButton]="true"
                      applyValueMode="useButtons"
                      i18n-noDataText="@@noTaskTagsInCatalog"
                      noDataText="No tags yet – create them under Administration → Tags."
                    ></dx-tag-box>
                    <span class="task-tags-placeholder" i18n="@@select">Select</span>
                  </div>
                  @if (taskTags.length === 0) {
                    <a class="task-tags-empty-link" routerLink="/config/tags/tasks" i18n="@@createTaskTagsLink">
                      Create tags under "Administration" → "Tags"
                    </a>
                  }
                  @if (getTaskTags(editData.tagIds).length) {
                    <div class="task-tags-pills">
                      @for (tag of getTaskTags(editData.tagIds); track tag.id) {
                        <gpd-pill
                          [text]="tag.name"
                          backgroundColor="#A7C687"
                          color="#31451C"
                          [removable]="true"
                          (onRemove)="removeTag(tag.id)"
                        ></gpd-pill>
                      }
                    </div>
                  }
                </div>
              </dxi-item>
            </dxi-item>

            <dxi-item itemType="simple" [colSpan]="2" [visible]="!!editData.rules?.length">
              <dxo-label i18n-text="@@rules" text="Rules" />
              <div *dxTemplate class="rules-field">
                @for (rule of editData.rules ?? []; track $index) {
                  <span class="rule-chip" [class.inactive]="!rule.isActive" [attr.title]="rule.isActive ? null : inactiveRuleTitle">
                    <span class="rule-dot"></span><span class="rule-name">{{ rule.name }}</span>
                  </span>
                }
              </div>
            </dxi-item>

            <dxi-item itemType="group" [colSpan]="2">
              <div *dxTemplate class="task-form-buttons">
                <!-- #4938: opens the rules popup; left, apart from Cancel / Save -->
                <app-gpd-button
                  class="rules-add"
                  type="text"
                  icon="add"
                  i18n-text="@@ruleAdd"
                  text="Add rule"
                  (onClick)="rulesVisible = true"
                ></app-gpd-button>
                <app-gpd-button
                  i18n-text="@@cancel"
                  text="Cancel"
                  type="secondary"
                  (onClick)="cancel()"
                  icon="cancel"
                ></app-gpd-button>
                <app-gpd-button
                  i18n-text="@@save"
                  text="Save"
                  type="primary"
                  (onClick)="form.instance.validate().isValid && save()"
                  icon="tick"
                ></app-gpd-button>
              </div>
            </dxi-item>
          </dx-form>
        </div>
      </div>
    } @else {
      <div class="summary-item-content-wrapper">
        <div class="summary-item-content">
          <app-svg-icon
            *ngIf="task.type === TaskTypeEnum.Group"
            icon="chevron-down"
            [size]="24"
            [strokeWidth]="2"
            color="var(--color-grey-900)"
            [class.expanded]="task.expanded"
            class="expanded-icon gpd-button-icon"
            (click)="toggleExpanded()"
          ></app-svg-icon>
          <app-svg-icon
            [icon]="task.type === TaskTypeEnum.Group ? 'group-items' : 'check-list'"
            [size]="24"
            [strokeWidth]="2"
            color="var(--color-grey-900)"
          ></app-svg-icon>
          <span class="item-number">{{ task.nr }}</span>
          <span class="task-title">{{ task.title }}</span>
          <span class="task-id">ID: {{ task.id }}</span>
          <app-svg-icon
            *ngIf="task.type !== TaskTypeEnum.Group"
            [icon]="priorities[task.priority ?? 3].icon"
            [size]="24"
            [strokeWidth]="2"
            [color]="priorities[task.priority ?? 3].color"
          ></app-svg-icon>
          <app-svg-icon
            *ngIf="task.siteTask && task.type !== TaskTypeEnum.Group"
            icon="location"
            [size]="24"
            [strokeWidth]="2"
            color="var(--color-primary)"
          ></app-svg-icon>
          @if (activeRuleCount(task)) {
            <span class="rule-indicator" i18n-title="@@activeRules" title="Active rules">
              <app-svg-icon icon="bell" [size]="18" [strokeWidth]="2" color="var(--color-primary)"></app-svg-icon>
              {{ activeRuleCount(task) }}
            </span>
          }

          <gpd-pill
            *ngIf="task.type !== TaskTypeEnum.Group"
            [text]="getTaskTypeText(task.type)"
            backgroundColor="#FEE086"
            color="#6B530A"
          >
          </gpd-pill>

          <gpd-pill
            *ngIf="task.departmentId && task.type !== TaskTypeEnum.Group"
            [text]="getTaskDepartmentText(task.departmentId)"
            backgroundColor="#F6DCDC"
            color="#A90000"
          >
          </gpd-pill>
          @if (task.type !== TaskTypeEnum.Group) {
            @for (areaTypeId of task.areaTypeIds; track areaTypeId) {
              <gpd-pill
                [text]="getAreaTypeText(areaTypeId)"
                backgroundColor="var(--color-grey-100)"
                color="var(--color-grey-700)"
                [hasBorder]="false"
              >
              </gpd-pill>
            }
          }
          @if (task.type !== TaskTypeEnum.Group) {
            @for (tag of getTaskTags(task.tagIds); track tag.id) {
              <gpd-pill [text]="tag.name" backgroundColor="#A7C687" color="#31451C"></gpd-pill>
            }
          }
        </div>
      </div>
      <div class="item-actions">
        @if (allowEdit && !isArchived && task.type === TaskTypeEnum.Group) {
          <app-gpd-button
            icon="add"
            type="text"
            (click)="startAdd(task)"
            i18n-text="@@addTask"
            text="Add task"
          ></app-gpd-button>
        }
        @if (allowEdit) {
          <app-svg-icon
            icon="edit"
            [size]="18"
            [strokeWidth]="2"
            color="var(--color-grey-500)"
            class="gpd-button-icon"
            (click)="$event.stopPropagation(); startEdit()"
          ></app-svg-icon>
        }
        @if (allowArchive) {
          <app-svg-icon
            icon="archive"
            [size]="18"
            [strokeWidth]="2"
            color="var(--color-grey-500)"
            class="gpd-button-icon"
            i18n-title="@@archive"
            title="Archivieren"
            (click)="$event.stopPropagation(); onArchive.emit()"
          ></app-svg-icon>
        }
        @if (allowDelete) {
          <app-svg-icon
            icon="delete"
            [size]="18"
            [strokeWidth]="2"
            color="var(--color-red-500)"
            class="gpd-button-icon"
            (click)="$event.stopPropagation(); onDelete.emit()"
          ></app-svg-icon>
        }
      </div>
    }
  </div>
</div>

@if (editData != null) {
  <app-task-rules-popup
    [(visible)]="rulesVisible"
    [task]="editData"
    [allTasks]="allTasks"
    [departments]="departmentTypes"
    [users]="users"
    [taskPackages]="taskPackages"
    [contractTypes]="contractTypes"
    [contractStatuses]="contractStatuses"
    (apply)="onRulesApplied($event)"
  ></app-task-rules-popup>
}

